import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { getformListItemsdatas } from '@/utils/utils';
let _ = require('lodash');
export default {
  data() {
    return {
      heightdata: false,
      List: [],
      defaultdataList: [],
      formObj: {
        map_type2: '',
        place_name: ''
      },
      listStyle: {},
      upFlag: false,
      listCollapsed: false,
      query: this.$route.query || {},
      loading: true,
      typeoptions: [],
      pointform: {
        formId: '165054',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      // 点位查询字段集合
      dataflag: false,
      cTemplate: 0
    };
  },
  components: {},
  watch: {
    '$attrs.formoption': {
      handler(val) {
        if (val) this.getTypeOptions(val);
      },
      deep: true
    },
    '$attrs.datalist': {
      handler(val) {
        this.cTemplate = val.template;
        if (val.template === 1) {
          this.List = [...val.data];
          this.defaultdataList = [...val.data];
          if (this.List.length > 0) this.loading = false;
        } else {
          if (this.dataflag) return;
          this.dataflag = true;
          this.getALLData();
        }
      },
      deep: true
    },
    '$attrs.style': {
      handler(val) {
        this.listStyle = {
          ...val
        };
        delete this.listStyle.width;
      },
      deep: true
    }
  },
  computed: {
    isFidListToggle() {
      return this.query.fid === '343891' && !this.$attrs.isMobile;
    }
  },
  mounted() {
    this.query = this.$route.query;
    this.pointform.deptId = this.$route.query.fid;
  },
  methods: {
    getTypeOptions(data) {
      this.typeoptions = [];
      if (data.length > 0) {
        data.forEach(elem => {
          let item = elem.itemformdata;
          let obj = {
            value: item.title,
            label: item.title,
            children: []
          };
          // console.log(item);
          if (item.json && item.json.length > 0) {
            let children = [...JSON.parse(item.json.replace(/(<\/?p.*?>)/gi, ''))];
            let childrenArr = [];
            children.forEach(child => {
              let cobj = {
                value: child.title,
                label: child.title
              };
              childrenArr.push(cobj);
            });
            obj.children = childrenArr;
          }
          this.typeoptions.push(obj);
        });
        // console.log(`this.typeoptions`, this.typeoptions);
      }
    },
    gosearch() {
      let filters = {};
      Object.keys(this.formObj).forEach(item => {
        filters[item] = this.formObj[item] === '' || this.formObj[item] === null ? [] : typeof this.formObj[item] === 'string' ? this.formObj[item] : this.formObj[item].join('/');
      });
      let cacheData = _.cloneDeep(this.defaultdataList);
      let filterArray = this.multiFilter(cacheData, filters);
      let data = JSON.parse(JSON.stringify(filterArray));
      this.List = data;
    },
    // 静态数据筛选
    multiFilter(array, filters) {
      const filterKeys = Object.keys(filters);
      return array.filter(item => {
        let itemflag = filterKeys.every(key => {
          // 自定义判断
          if (key === 'place_name') {
            return !!~item.itemformdata[key].indexOf(filters[key]);
          }
          if (!filters[key].length) return true;
          return !!~filters[key].indexOf(item.itemformdata[key]);
        });
        return itemflag;
      });
    },
    listmarkerclick(item) {
      this.$emit('listclick', item);
    },
    listUp() {
      this.upFlag = !this.upFlag;
      this.$emit('listup', this.upFlag);
    },
    listDown() {
      this.upFlag = false;
    },
    toggleListCollapse() {
      this.listCollapsed = !this.listCollapsed;
    },
    getALLData() {
      let that = this;
      this.$api.singleadvanceSearch(this.pointform).then(res => {
        // console.log(res);
        if (res.totalRow > 0) {
          if (that.pointform.page === 1) that.defaultdataList = [];
          let dataList = res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[itemformdata[key].alias] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            return item;
          });
          that.defaultdataList = that.pointform.page === 1 ? dataList : that.defaultdataList.concat(dataList);
          if (res.totalPage > 1) that.pointform.page++;
          if (res.totalPage === 1 || res.totalPage > 1 && res.totalPage + 1 === that.pointform.page) {
            that.loading = false;
            that.List = that.defaultdataList;
          }
          if (res.totalPage > 1 && res.totalPage >= that.pointform.page) that.getALLData();
        }
      });
    }
  }
};